var map = {
	"./Pagination.vue": "qWq5"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fUC";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/components nonrecursive \.vue$
// module id = 8fUC
// module chunks = 1